const Footer = () => {
  return (
    <footer class="footer">
      <div class="container">
        <div class="sectionleft">
          <img
            src="https://c3store.nyc3.digitaloceanspaces.com/mwpackaging/vectLogoFull.png"
            alt=""
          />
        </div>
        <div class="sectionright">
          <p>
            <strong>Midwest Packaging Partners</strong>
          </p>
          <p>simeon@midwestpackagingpartners.com</p>
          <p>655 Ertel Lane North Vernon, IN 47265</p>
          <p>812-350-2809</p>
        </div>
        <p class="copyright">
          &copy; 2025 Midwest Packaging Partners. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
